/*
 * @Author: zhaihaooran
 * @Date: 2021-04-12 21:28:07
 * @LastEditors: OBKoro1
 * @FilePath: /umu_mobile/src/businessCommon/components/@waterMark/waterMark.tsx
 */
import React, { useRef, useEffect } from 'react';
import { useBodyResize, useOrientation } from '@umu/umu-react-hooks';
import { IWaterMarkProps } from '@umu/umu-types';
import './waterMark.scss';

export function WaterMark(props: IWaterMarkProps) {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const w = useBodyResize();
    const [orientation] = useOrientation();
    const {
        text = 'UMU',
        isFullscreen,
        color = '#999',
        rotate: degree = 30,
        font = 'sans-serif',
        trasparency = 0.2,
        renderState,
        isShowWaterMark = false,
    } = props;

    const { size = 18, offsetY = 100, offsetX: space = 50 } = props;

    useEffect(() => {
        if (!canvasRef.current || !text || !isShowWaterMark) {
            return;
        }
        const canvasElem = canvasRef.current;
        const ctx = canvasElem.getContext('2d') as CanvasRenderingContext2D;
        const parentElement = canvasRef.current.parentElement;
        if (!parentElement) {
            return;
        }
        const maskHeight = canvasRef.current.parentElement!.clientHeight;
        const maskWidth = canvasRef.current.parentElement!.clientWidth;
        canvasElem.width = maskWidth;
        canvasElem.height = maskHeight;
        ctx.clearRect(0, 0, maskHeight, maskWidth);
        const offsetX = Math.ceil(ctx.measureText(text).width) + space;
        let drawAreaWidth = maskHeight / Math.sin((Math.PI / 180) * degree);
        // 要遮住全部的，高度必须是边长为斜线长的正方形。
        // 因为要斜着，所以需要往左移动一部分, 先求出和正方形底边，要朝degree方向移动的距离, 然后在计算x周方向要移动的距离
        const offsetDrawArea =
            (Math.sin((Math.PI / 180) * degree) * maskHeight) / Math.sin((Math.PI / 180) * (90 - degree));
        drawAreaWidth = Math.max(drawAreaWidth, Math.sqrt(Math.pow(maskHeight, 2) + Math.pow(maskWidth, 2)));
        const rows = Math.ceil(drawAreaWidth / offsetY);
        const columns = Math.ceil(drawAreaWidth / offsetX);

        ctx.font = `${size}px ${font}`;
        ctx.globalAlpha = trasparency;
        ctx.fillStyle = color;
        ctx.rotate((-degree * Math.PI) / 180);
        ctx.translate(-offsetDrawArea, 0);
        for (let i = 0; i < rows; i++) {
            for (let j = 0; j < columns; j++) {
                if ((i + j) % 2 === 1) {
                    ctx.fillText(text, offsetX * j, offsetY * i);
                }
            }
        }
    }, [isFullscreen, text, w, orientation, renderState, isShowWaterMark, canvasRef]);

    return <canvas ref={canvasRef}></canvas>;
}
